import { NgModule } from "@angular/core";
import { B2cAssessmentComponent } from "./b2c-assessment.component";
import { CommonModule } from "@angular/common";
import { LibModule } from "@ui-components/lib.module";
import { ReactiveFormsModule } from "@angular/forms";

@NgModule({
    declarations: [
        B2cAssessmentComponent
    ],
    imports: [
        CommonModule,
        LibModule,
        ReactiveFormsModule
      ]
})
export class B2cAssessmentModule { }